<template>
    <div class="p-col-12">
        <page-header title="forms.account.accountTitle"/>
        <form @submit.prevent="save">
            <card :header="$t('forms.client.card-contact-information')" class="p-col-12" >
                <ImageUpload v-if="form.id" @change="setAvatar" v-model="form.avatar" class="p-col-12 text-center"></ImageUpload>
                <CoffInputText v-model="form.name" label="forms.account.name" class="p-col" :error="validation.name" ></CoffInputText>

                <div class="p-col-12">
                    <Button :label="$t('btn.save')" class="p-button-success" style="float: right;"/>
                </div>
            </card>
        </form>

        <form @submit.prevent="changePassword">
            <card :header="$t('forms.account.passwordTitle')" class="p-col-12" >
                <CoffInputPassword class="p-col-12 p-md-4 p-lg-4" v-model="passwordForm.informedPassword" label="forms.account.currentPassword" :error="passwordValidation.informedPassword" :feedback="false"></CoffInputPassword>
                <CoffInputPassword class="p-col-12 p-md-4 p-lg-4" v-model="passwordForm.newPassword" label="forms.account.newPassword" :error="passwordValidation.newPassword"></CoffInputPassword>
                <CoffInputPassword class="p-col-12 p-md-4 p-lg-4" v-model="passwordForm.repeatedPassword" label="forms.account.repeatNewPassword" :error="passwordValidation.repeatedPassword"></CoffInputPassword>

                <div class="p-col-12">
                    <Button :label="$t('btn.save')" class="p-button-success" style="float: right;"/>
                </div>
            </card>

        </form>

    </div>
</template>

<script>
    import CoffInputText from "@/components/inputs/CoffInputText";
    import CoffInputPassword from "@/components/inputs/CoffInputPassword";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import UserBusiness from "@/business/UserBusiness";
    import ValidationUtils from "@/utils/ValidationUtils";
    import ImageUpload from "@/components/image/ImageUpload";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";

    export default {
        name: "Account",
        components: {PageHeader, ImageUpload, CoffInputText, CoffInputPassword},

        data(){
            return {
                form: {},
                validation: {
                  name: false
                },
                passwordForm: {},
                passwordValidation: {
                    informedPassword:false,
                    newPassword:false,
                    repeatedPassword:false
                }
            }
        },

        async mounted() {
            EventBus.loadingPage(true);
            this.form = await UserBusiness.getLoggedUser();
            EventBus.loadingPage(false);
        },

        methods: {

            async save(){
                this.validation = ValidationUtils.basicValidation(this.validation, this.form);
                if(!this.validation.erros){
                    await UserBusiness.save(this.form, this.form.id)
                        .then((user) => {
                            ToastMessageBusiness.showSuccess();
                            EventBus.$emit('UPDATE_PROFILE', user);
                        })
                        .catch((e) => ToastMessageBusiness.showError(e.message));
                }
            },

            async changePassword(){
                this.passwordValidation = ValidationUtils.basicValidation(this.passwordValidation, this.passwordForm);
                if(!this.passwordValidation.erros){
                    await UserBusiness.changePassword(this.passwordForm, this.form.id)
                        .then(() => ToastMessageBusiness.showSuccess('password.changed'))
                        .catch((e) => ToastMessageBusiness.showError(e.message));
                }
            },

            setAvatar(avatar){
                this.form.avatar = avatar;
            }

        }

    }
</script>

<style scoped>

</style>
